import { use, useRef } from "react";
import type { WheelEvent } from "react";

import { SettingsContext } from "lib/settings/use-settings";

import { NavigationContext } from "./use-navigation";

export function useMouseWheel() {
  const { nextPage, prevPage } = use(NavigationContext)!;
  const { layoutDirection } = use(SettingsContext)!;

  const lastNavigationTime = useRef(0);
  const deltaSum = useRef(0);

  function handleWheel(e: WheelEvent) {
    if (layoutDirection !== "horizontal") return;

    e.preventDefault();

    if (Date.now() - lastNavigationTime.current < 500) return;

    deltaSum.current += e.deltaY;

    if (Math.abs(deltaSum.current) > 50) {
      if (deltaSum.current > 0) {
        nextPage();
      } else {
        prevPage();
      }

      lastNavigationTime.current = Date.now();
      deltaSum.current = 0;
    }
  }

  return { handleWheel };
}
